import React from "react";
import { Box, Paper, Stack } from "@mui/material";
import stripe from "src/assets/icons/stripe";
import Icon from "src/components/icon";
import styled from "styled-components";
import fetchStatus from "../../utils/api/fetch-status";
import ShowWithSkeleton from "../../utils/show-with-skeleton";

const SubscriptionPaper = styled(Paper)`
    border-radius: 14px;
    min-height: 320px;
`;

const CardTitle = styled.span`
    font-size: 18px;
    font-weight: 500;
`;

const DetailsTitle = styled.span`
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const DetailsDescription = styled.span`
    font-size: 12px;
    font-weight: 300;
    color: ${({ theme }) => theme.palette.text.secondary};
`;

const PaymentDetailsCard = ({ paymentMethod, subscriptionApi }) => {
    if (
        subscriptionApi.status !== fetchStatus.PENDING &&
        subscriptionApi.status !== fetchStatus.REFETCHING &&
        !paymentMethod
    )
        return null;

    return (
        <SubscriptionPaper style={{ width: "min(80vw, 350px)" }}>
            <Box p={3}>
                <Stack direction="column" spacing={2}>
                    <CardTitle>Payment Details</CardTitle>
                    <Box pt={0}>
                        <Stack direction="column" spacing={2}>
                            <Stack direction="column" spacing={1}>
                                <DetailsTitle>Payment Method</DetailsTitle>
                                <ShowWithSkeleton variant="text" fetchAction={subscriptionApi}>
                                    <DetailsDescription>
                                        <Icon svg={stripe} width="82px" height="34px" />
                                    </DetailsDescription>
                                </ShowWithSkeleton>
                            </Stack>
                            <Stack direction="column" spacing={1}>
                                <DetailsTitle>Billing Address</DetailsTitle>
                                <Stack direction="column" spacing={0}>
                                    <ShowWithSkeleton variant="text" fetchAction={subscriptionApi}>
                                        <DetailsDescription>
                                            {paymentMethod &&
                                                paymentMethod.billingDetails.address.line1}
                                        </DetailsDescription>
                                    </ShowWithSkeleton>
                                    <ShowWithSkeleton variant="text" fetchAction={subscriptionApi}>
                                        <DetailsDescription>
                                            {paymentMethod &&
                                                paymentMethod.billingDetails.address.line2}
                                        </DetailsDescription>
                                    </ShowWithSkeleton>
                                    <ShowWithSkeleton variant="text" fetchAction={subscriptionApi}>
                                        <DetailsDescription>
                                            {paymentMethod &&
                                                paymentMethod.billingDetails.address.city}
                                        </DetailsDescription>
                                    </ShowWithSkeleton>
                                    <ShowWithSkeleton variant="text" fetchAction={subscriptionApi}>
                                        <DetailsDescription>
                                            {paymentMethod &&
                                                paymentMethod.billingDetails.address.postal_code}
                                        </DetailsDescription>
                                    </ShowWithSkeleton>
                                    <ShowWithSkeleton variant="text" fetchAction={subscriptionApi}>
                                        <DetailsDescription>
                                            {paymentMethod &&
                                                paymentMethod.billingDetails.address.country}
                                        </DetailsDescription>
                                    </ShowWithSkeleton>
                                </Stack>
                            </Stack>
                        </Stack>
                    </Box>
                </Stack>
            </Box>
        </SubscriptionPaper>
    );
};

export default PaymentDetailsCard;
